import { render, staticRenderFns } from "./Sender.vue?vue&type=template&id=6a34269e"
import script from "./Sender.vue?vue&type=script&lang=js"
export * from "./Sender.vue?vue&type=script&lang=js"
import style0 from "./Sender.vue?vue&type=style&index=0&id=6a34269e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports